import {
  LeaseStatusBadge,
  LeaseStatusBadgeProps
} from "views/renters/components/Table/LeaseStatusBadge";
import { Row } from "views/renters/components/Table/RowDrawer/components/Row";
import { AlgoliaUser } from "views/renters/types";

type Props = {
  selectedRowData: AlgoliaUser;
};

export const PMSRenterDetails = ({ selectedRowData }: Props) => {
  return (
    <div className="flex h-full flex-col gap-4">
      <div className="pb-2 pt-4">
        <p className="text-sm font-bold text-content-1000">Personal</p>
      </div>

      <div className="flex flex-col gap-4">
        <Row title="Person ID" value={selectedRowData.customer.id} />
        <Row title="Phone" value={selectedRowData.customer.phone} />
        <Row title="Email" value={selectedRowData.customer.email} />
        <Row title="Date of birth" value={selectedRowData.customer.dob} />
      </div>

      <div className="pb-2 pt-4">
        <p className="text-sm font-bold text-content-1000">Residence</p>
      </div>

      <div className="flex flex-col gap-4">
        <Row title="Property" value={selectedRowData.property.name} />
        <Row
          title="Unit"
          value={
            selectedRowData.building && selectedRowData.unit
              ? `${selectedRowData.building}, ${selectedRowData.unit}`
              : selectedRowData.building || selectedRowData.unit
          }
        />
        <Row
          title="Address"
          value={
            selectedRowData.property.unit.address1 ||
            selectedRowData.property.address1
          }
        />
      </div>

      <div className="pb-2 pt-4">
        <p className="text-sm font-bold text-content-1000">Lease</p>
      </div>

      <div className="flex flex-col gap-4">
        <Row
          title="Status"
          value={
            <LeaseStatusBadge
              status={selectedRowData.status as LeaseStatusBadgeProps["status"]}
            />
          }
        />
        <Row title="Lease ID" value={selectedRowData.id} />
        <Row
          title="Rent"
          value={selectedRowData.rent && `$${selectedRowData.rent}`}
        />
        <Row
          title="Lease start"
          type="Date"
          value={selectedRowData.startDate}
        />
        <Row title="Lease end" type="Date" value={selectedRowData.endDate} />
        <Row title="Move in" type="Date" value={selectedRowData.moveInDate} />
        <Row title="Move out" type="Date" value={selectedRowData.moveOutDate} />
      </div>
    </div>
  );
};
